var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompleteSignupProgress',{attrs:{"currentStep":_vm.currentStep,"stepNames":['Set up profile', 'Invite team (optional)']}})
}
var staticRenderFns = []

export { render, staticRenderFns }